/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { organisationAtsAutomationSettingsUpdate } from '../../axios/organisationAtsAutomationSettingsUpdate'
import type {
	OrganisationAtsAutomationSettingsUpdateError,
	OrganisationAtsAutomationSettingsUpdatePathParams,
	OrganisationAtsAutomationSettingsUpdateRequest,
	OrganisationAtsAutomationSettingsUpdateResponse,
} from '../../types/OrganisationAtsAutomationSettingsUpdate'

export const organisationAtsAutomationSettingsUpdateMutationKey = () =>
	[{ url: '/organisations/:organisation/ats-automation-settings' }] as const

export type OrganisationAtsAutomationSettingsUpdateMutationKey = ReturnType<
	typeof organisationAtsAutomationSettingsUpdateMutationKey
>

export type OrganisationAtsAutomationSettingsUpdateVariables = {
	organisation: OrganisationAtsAutomationSettingsUpdatePathParams['organisation']
	data: OrganisationAtsAutomationSettingsUpdateRequest
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationAtsAutomationSettingsController.php OrganisationAtsAutomationSettingsController::update */
export function useOrganisationAtsAutomationSettingsUpdate<TContext = unknown>(
	options?: UseMutationOptions<
		OrganisationAtsAutomationSettingsUpdateResponse,
		AxiosError<OrganisationAtsAutomationSettingsUpdateError>,
		OrganisationAtsAutomationSettingsUpdateVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: organisationAtsAutomationSettingsUpdateMutationKey(),
		mutationFn: ({ organisation, data }: OrganisationAtsAutomationSettingsUpdateVariables) =>
			organisationAtsAutomationSettingsUpdate(organisation, data, config).then(res => res.data),
		...options,
	})
}
